import LogRocket from 'shared/logrocket';
import PublicEnv from 'shared/utils/public-env';
/*
 * NOTE: Apollo grabs a reference to the network.  We need to instantiate
 * LogRocket before Apollo otherwise LogRocket can't see the graphql traffic.
 */ export function initLogRocket(logrocketId) {
    if (logrocketId) {
        try {
            LogRocket.init(logrocketId, {
                release: PublicEnv.currentVersion,
                dom: {
                    inputSanitizer: true
                },
                network: {
                    isEnabled: true,
                    requestSanitizer: function(request) {
                        var _request_headers;
                        if (request === null || request === void 0 ? void 0 : (_request_headers = request.headers) === null || _request_headers === void 0 ? void 0 : _request_headers.authorization) {
                            request.headers.authorization = 'redacted';
                        }
                        return request;
                    }
                },
                mergeIframes: true
            });
        } catch (e) {
            console.error('Failed to load log rocket!', e);
        }
    }
}
export default {
    initLogRocket: initLogRocket
};
